module.exports = __webpack_public_path__ + "img/dan.98c3b4a6.png";